import React from 'react';
import cn from 'classnames';

import { COURSE_STRUCTURES } from 'constants/common';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';

import { CoursePreviewLayout } from 'components/Layout';

import { Header } from '../CoursePreviewPage/components/Header';
import { Modules } from '../CoursePreviewPage/components/Modules';
import { CourseResult } from '../CoursePreviewPage/components/CourseResult';

import styles from './ArcadePreviewPage.module.scss';

const ArcadePreviewPage = ({
  loading,
  arcade,
  previewType,
  setPreviewType,
}: {
  loading: any;
  arcade: any;
  previewType: any;
  setPreviewType: any;
}) => {
  return (
    <CoursePreviewLayout
      setPreviewType={setPreviewType}
      type={arcade && arcade.type}
    >
      {loading ? (
        <Loading className={styles.loading} />
      ) : (
        <div
          className={cn(styles.page, {
            [styles.pluginPage]:
              previewType === getTranslation('common.text.plugin'),
          })}
        >
          <div
            className={
              previewType === getTranslation('common.text.web') && styles.header
            }
          >
            <Header {...arcade} previewType={previewType} />
            {arcade.resultPreview && (
              <CourseResult
                preview={arcade.resultPreview}
                previewType={previewType}
              />
            )}
          </div>
          {arcade.structure === COURSE_STRUCTURES.MODULES && (
            <Modules modules={arcade.modules} />
          )}
        </div>
      )}
    </CoursePreviewLayout>
  );
};

export default React.memo(ArcadePreviewPage) as any;
